import { Context } from "@nuxt/types/app";
import { isFinite } from "lodash-es";

interface ByteFromMbPlugin {
  getBytesFromMB(number: number): number;
}

export default function (context: Context): ByteFromMbPlugin {
  function getBytesFromMB(number: number): number {
    if (!isFinite(number)) {
      return 0;
    }

    return number * (1024 * 1024);
  }

  return { getBytesFromMB };
}
